export const BASE_CAMPAIGN_NAME = 'haendlerwebsite';

export type UtmMappingEntry = {
    utmTerm?: string | null;
    mappingValue?: string | null;
};

/**
 * Non-campaign (AlwaysOn / General-Lead) Media-KMP codes.
 * Campaign-specific mappings stay CMS-managed on Vertriebsaktionsseiten.
 */
export const GENERAL_LEAD_UTM_MAPPING: UtmMappingEntry[] = [
    { utmTerm: 'KMP-02401-W01P', mappingValue: 'google-suchnetzwerkkampagne-2026' },
];

export function findUtmMappingValue(utmTerm: string | undefined, mappings: UtmMappingEntry[]): string | undefined {
    const normalizedUtmTerm = utmTerm?.trim();
    if (!normalizedUtmTerm) {
        return undefined;
    }

    const match = mappings.find((mapping) => mapping.utmTerm?.trim() === normalizedUtmTerm);
    const mappingValue = match?.mappingValue?.trim();
    return mappingValue || undefined;
}

export function buildCampaignName(mappingValue: string): string {
    return `${BASE_CAMPAIGN_NAME}-${mappingValue}`;
}

export function resolveMappedCampaignName(
    utmTerm: string | undefined,
    mappings: UtmMappingEntry[],
): string | undefined {
    const mappingValue = findUtmMappingValue(utmTerm, mappings);
    return mappingValue ? buildCampaignName(mappingValue) : undefined;
}

export function resolveCampaignName(utmTerm: string | undefined, mappings: UtmMappingEntry[] = []): string {
    return (
        resolveMappedCampaignName(utmTerm, mappings) ??
        resolveMappedCampaignName(utmTerm, GENERAL_LEAD_UTM_MAPPING) ??
        BASE_CAMPAIGN_NAME
    );
}
